import Vue from 'vue'
import Router from 'vue-router'
import main from '../views/basalPage'
import login from '../views/login'
import twoLevelRouter from './twoLevelRouter'
import serviceDetail from '../components/contentManagement/serviceDetail'

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this,location).catch(error => error)
}
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login => require(['../views/login'], login)
    },
    {
      path: '/',
      name: 'main',
      component: main,
      children: twoLevelRouter
    },
    { //内容管理=>服务管理=>编辑服务详情
      path: '/serviceDetail',
      name: 'serviceDetail',
      component: serviceDetail => require(['../components/contentManagement/serviceDetail'], serviceDetail),
    },
    { //内容管理=>服务管理=>服务详情预览
      path: '/servicePreview',
      name: 'servicePreview',
      component: servicePreview => require(['../components/contentManagement/servicePreview'], servicePreview),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js